module.exports = __webpack_public_path__ + "img/SMS-Notify.494db28a.svg";